import React, { useState, useRef, Touch} from "react";
import { StyleSheet, TouchableOpacity, View,  } from 'react-native';

import Utilities from '../~Utilities/Utilities';
import { Text, } from 'react-native';
import Text2 from '../C_Text/Text2';
import Text3 from '../C_Text/Text3';
import Text4 from '../C_Text/Text4';
import LookBackBar from '../C_General/LookBackBar';
import Order from "../C_Popups/SettingsAndOrders";
import ChartConfig from "../C_Popups/ChartConfig";
import { Data, PosData } from "../~Utilities/Data";
import { ConnectionMkt, ConnectionOrd } from "../~Utilities/Connection";
import OB from './OB';
import ChartEx from "../C_General/ChartEx";
import { AppMain, FontInfo,  } from "../~Utilities/Constants";
import Text2Invisible from "../C_Text/Text2Invisible";
import FeelingLucky from "../C_Text/FeelingLucky";

/*   ---------------------------------------------------------------------   */

export interface IQBInfo
{
  oData           : Data;
  iSettIndex      : number;
  onSelectAccount : (oData : PosData) => void;
  bindEvent       : (onEvent    : (() => void), 
                     bSubscribe : boolean) => void,

  dotClicked : (iIndex   : number,
                bScroll  : boolean,
                bAnimated: boolean) => void
}

/*   ---------------------------------------------------------------------   */

export default class QB extends React.Component<IQBInfo>
  {
  //const [b_available, setAvailable]        = useState(true);
  public  oOrderRef    : Order | null        = null;
  public  oChartConfig : ChartConfig | null  = null;
  public  oChartRef    : ChartEx | null      = null;
  private bShowAlt                           = false;
  public  oEvtLink     : FeelingLucky | null = null;

  /*   -------------------------------------------------------------------   */

  state = {visible:false};

  // function getFmt(price : number,
  //                 props)
  // {
  // if (props.display_fmt)
  //   return(PriceFormat.getFlaggedDisplayFormat(price, props.display_fmt));
  // else
  //   return(price.toFixed(props.f2qp));
  // }

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  this.state             = {visible:true};
  this.Hide              = this.Hide.bind(this);
  this.Show              = this.Show.bind(this);
  this.GetTradePrice     = this.GetTradePrice.bind(this);
  this.GetTradeSize      = this.GetTradeSize.bind(this);
  this.GetTradePriceType = this.GetTradePriceType.bind(this);
  }

    /*   -------------------------------------------------------------------   */

  Hide()
  {
  this.setState({visible:false})
  }

  /*   -------------------------------------------------------------------   */

  Show()
  {
  this.setState({visible:true})
  }

  /*   -------------------------------------------------------------------   */

  GetTradePrice()
  {
    if (this.props.oData.last == undefined)
    {
    if (this.props.oData.mode == "End of Day") 
      {
      if (this.bShowAlt && this.props.oData.settlement)
        return(ConnectionMkt.getFmt(this.props.oData.settlement, this.props.oData));

      else if (this.props.oData.close)
        return(ConnectionMkt.getFmt(this.props.oData.close, this.props.oData));
      }
    else
      {
      if (this.bShowAlt == false && this.props.oData.adj_close)
        return(ConnectionMkt.getFmt(this.props.oData.adj_close, this.props.oData));
      else if (this.props.oData.close)
        return(ConnectionMkt.getFmt(this.props.oData.close, this.props.oData));
      }
    }
  else if (this.props.oData.mode == "End of Day")
      {
      if (this.bShowAlt && this.props.oData.settlement)
        return(ConnectionMkt.getFmt(this.props.oData.settlement, this.props.oData));

      else if (this.props.oData.close)
        return(ConnectionMkt.getFmt(this.props.oData.close, this.props.oData));
      }
  
  return(ConnectionMkt.getFmt(this.props.oData.last, this.props.oData)); 
  }

  /*   -------------------------------------------------------------------   */

  GetTradePrice_old()
  {
    if (this.props.oData.mode == "End of Day" || this.props.oData.last == undefined) //End of Day
      {
      if (this.bShowAlt  && this.props.oData.adj_close)
        return(ConnectionMkt.getFmt(this.props.oData.adj_close, this.props.oData));

      if (this.bShowAlt && this.props.oData.settlement)
        return(ConnectionMkt.getFmt(this.props.oData.settlement, this.props.oData));

      if (this.props.oData.close)
        return(ConnectionMkt.getFmt(this.props.oData.close, this.props.oData));
      }

    // if (this.props.oData.last_size == 0)
    //     {
    //     if (this.props.oData.close)
    //       return(ConnectionMkt.getFmt(this.props.oData.close, this.props.oData));
    //     else if (this.props.oData.settlement)
    //       return(ConnectionMkt.getFmt(this.props.oData.settlement, this.props.oData));
    //     else if (this.props.oData.adj_close)
    //       return(ConnectionMkt.getFmt(this.props.oData.adj_close, this.props.oData));
    //     else
    //       return(" ");
    //     } 
    else
      return(ConnectionMkt.getFmt(this.props.oData.last, this.props.oData));
  }

  /*   -------------------------------------------------------------------   */

  // GetTradeSize_old()
  // {
  //   if (this.props.oData.mode == "End of Day")
  //     {
  //     if (this.props.oData.close)
  //       return("(close)");
  //     }

  //   if (this.props.oData.last == undefined)
  //       {
  //       if (this.props.oData.close)
  //         return("(close)");
  //       else if (this.props.oData.settlement)
  //         return("(stlmt)");
  //       else
  //         return(" ");
  //       } 
  //   else
  //     return("(" + this.props.oData.last_size + ")");
    
  // }

  /*   -------------------------------------------------------------------   */

  GetTradeSize()
  {
    if (this.props.oData.last == undefined)
      {
      if (this.props.oData.mode == "End of Day") 
        {
        if (this.bShowAlt && this.props.oData.settlement)
          return(" ");
  
        else if (this.props.oData.close)
          return(" ");
        }
      else
        {
        if (this.bShowAlt == false && this.props.oData.adj_close)
          return(" ");
        else if (this.props.oData.close)
          return(" ");
        }
      }
    else if (this.props.oData.mode == "End of Day")
        {
        if (this.bShowAlt && this.props.oData.settlement)
          return(" ");
  
        else if (this.props.oData.close)
          return(" ");
        }
    
    if (this.props.oData.last_size)
      return("(" + this.props.oData.last_size + ")");
    else
      return(" ");
  }

  /*   -------------------------------------------------------------------   */

  GetTradeSize_old()
  {
    //return("(" + this.props.oData.last_size + ")");

    if (this.props.oData.mode == "End of Day" || this.props.oData.last_size == undefined)
      {
      // if (this.bShowAlt && this.props.oData.adj_close)
      //   return(" ");

      // if (this.bShowAlt && this.props.oData.settlement)
      //   return(" ");

      // if (this.props.oData.close)
        return(" ");
      }

    // if (this.props.oData.last_size == 0)
    //     {
    //     if (this.props.oData.close)
    //       return(" ");
    //     else if (this.props.oData.settlement)
    //       return(" ");
    //     else if (this.props.oData.adj_close)
    //       return(" ");
    //     else
    //       return(" ");
    //     } 
    else
      return("(" + this.props.oData.last_size + ")");
    
  }

  /*   -------------------------------------------------------------------   */

  GetTradePriceType()
  {
    if (this.props.oData.last == undefined)
      {
      if (this.props.oData.mode == "End of Day") 
        {
        if (this.bShowAlt && this.props.oData.settlement)
          return("sp");
  
        else if (this.props.oData.close)
          return("cl");
        }
      else
        {
        if (this.bShowAlt == false && this.props.oData.adj_close)
          return("adj cl");
        else if (this.props.oData.close)
          return("cl");
        }
      }
    else if (this.props.oData.mode == "End of Day")
        {
        if (this.bShowAlt && this.props.oData.settlement)
          return("sp");
  
        else if (this.props.oData.close)
          return("cl");
        }
    
    return(" ");


    if (this.props.oData.mode != "End of Day" && this.props.oData.last == undefined) //End of Day
      {
      if (this.bShowAlt == false && this.props.oData.adj_close)
        return("adj cl");
      else if (this.props.oData.close)
        return("cl");
      }

    if (this.props.oData.mode == "End of Day" || this.props.oData.last == undefined) //End of Day
      {
      if (this.bShowAlt && this.props.oData.adj_close)
        return("adj cl");

      if (this.bShowAlt && this.props.oData.settlement)
        return("sp");

      if (this.props.oData.close)
        return("cl");
      }

    // if (this.props.oData.last_size == 0)
    //     {
    //     if (this.props.oData.close)
    //       return("cl");
    //     else if (this.props.oData.settlement)
    //       return("sp");
    //     else if (this.props.oData.adj_close)
    //       return("adj cl");
    //     else
    //       return(" ");
    //     } 
    // else
      return(" ");
    
  }

  /*   -------------------------------------------------------------------   */

  render() 
    {
    if (this.state.visible == false)
      return(null);
    else  
    return (
    <View style={[styles.symbol_container, {backgroundColor:'transparent'}]}
      onLayout={(event) => {
        var {x, y, width, height} = event.nativeEvent.layout;

        if (OB.WHITE_HEIGHT == 0 || height > OB.WHITE_HEIGHT)
          {
          OB.WHITE_HEIGHT = height;

          //alert(OB.WHITE_HEIGHT);

          ConnectionOrd.UpdateFont();
          //alert(OB.WHITE_HEIGHT);
          //this.CenterBook();
          }
      }}
    >

        {/* <View style={styles.symbol_data_container}> */}

        <View style={[styles.view_center, {}]}>

        <FeelingLucky 
          ref={node => { this.oEvtLink = node; }}
          //bindEvent={this.props.bindEvent}
          //getValue={()=>{return(this.props.oData.is_evt_enabled)}}
          visible={AppMain.bEventTradeAdv && (this.props.oData.evt_avbl || this.props.oData.is_evt_enabled)} //this.props.oData.evt_avbl} 
          onPress={()=> {this.props.dotClicked(3, true, true); this.oEvtLink?.Hide(); }} />


          <View style={{ width:Utilities.WIDTH, backgroundColor:'transparent', flexDirection: "row"}}> 
            <Text2 name = "" bbb={this.props.bindEvent} style={[FontInfo.appStyles.txt_bold, {backgroundColor:'transparent', color: 'hotpink', flex:1, textAlign:"right"}]} ggg={()=>
                {
                  return(!this.props.oData.ask_size? " " : this.props.oData.ask_size)
                }}></Text2>
            {/* <Text style={Platform.OS === 'ios'? [styles.row_12_b, {backgroundColor:'white', color: 'silver'}] : {display: "none"}}>  </Text> */}
            <Text2 name = "" bbb={this.props.bindEvent} style={[FontInfo.appStyles.txt_bold, {backgroundColor:'transparent', color: 'gainsboro', paddingHorizontal:4}]} ggg={()=>
                {
                  return(!this.props.oData.ask_size? "No Ask" : "@")
                }}></Text2>
            <Text2 name = "" bbb={this.props.bindEvent} style={[FontInfo.appStyles.txt_bold, {textAlign:'left', backgroundColor:'transparent', color: 'hotpink', flex:1,}]} ggg={()=>
              {
                return(!this.props.oData.ask_size? " " : ConnectionMkt.getFmt(this.props.oData.ask, this.props.oData))
              }}></Text2>
          </View>

        {/* LAST LINE */}
        <View style={{width: '100%', backgroundColor:'transparent'}}>
        {/* LAST */}
          {/* <View style={{backgroundColor:'white', flex:1, flexDirection:'row',}}>
            <Text2 name = "" bbb={this.props.bindEvent} style={[styles.title_big, {opacity:0, }]} ggg={()=>{return(this.props.oData.last_size == 0? " " : ConnectionMkt.getFmt(this.props.oData.last, this.props.oData))}}></Text2>
            <View style={{backgroundColor:'white', flex:1, }}></View>
            <View style={{backgroundColor:'white', flex:1, justifyContent:'flex-end', marginBottom:8}}>
                <Text2 name = "" bbb={this.props.bindEvent} style={[styles.row_last, {color:'darkgrey'}]} ggg={()=>{return(this.props.oData.last_size == 0? " " :  "(" + this.props.oData.last_size + ")")}}></Text2>
            </View>
          </View> */}

          <View style={{backgroundColor:'transparent', flex:1, flexDirection:'row',}}>
            <Text2 name = "" bbb={this.props.bindEvent} style={[FontInfo.appStyles.txt_black, styles.title_big, {fontSize:FontInfo.iFontSize + 23, opacity:0, }]} ggg={this.GetTradePrice}></Text2>
            <View style={{backgroundColor:'transparent', flex:1, }}></View>
            <View style={{backgroundColor:'transparent', justifyContent:'flex-end', flex:1, marginLeft:-5, marginBottom:8}}>
                {/* <Text style={[FontInfo.appStyles.txt_bold, styles.row_last, {color:'darkgrey'}]}>cl</Text> */}
                
                {/* <TouchableOpacity style={{}} onPress={()=>{this.bShowSettle = !this.bShowSettle}}> */}
                {/* <TouchableOpacity style={{minHeight:30, marginLeft:-2, backgroundColor:'gray', justifyContent:'center'}} onPress={()=>{this.bShowSettle = !this.bShowSettle}}> */}
                <Text2Invisible bindEvent={this.props.bindEvent} 
                                onPress={()=>{this.bShowAlt = !this.bShowAlt}}
                                style={[FontInfo.appStyles.txt_bold, styles.row_last, {marginTop:3, color:'darkgrey', minHeight:25, backgroundColor:'transparent'}]} 
                                // pressable_style={{minHeight:40, position:'absolute', top:0, width:'100%', marginLeft:0, justifyContent:'flex-start'}}
                                pressable_style={{width:'100%', marginLeft:0, justifyContent:'flex-start', backgroundColor:'transparent'}}
                                getText={this.GetTradePriceType}/>
                {/* </TouchableOpacity> */}
                {/* </TouchableOpacity> */}
                <Text2 name = "" bbb={this.props.bindEvent} style={[FontInfo.appStyles.txt_bold, styles.row_last, {marginLeft:5, color:'darkgrey'}]} ggg={this.GetTradeSize}></Text2>
            </View>
          </View>

          <View style={{
            opacity:1,
            backgroundColor:'transparent', 
            justifyContent:'center',
            alignItems:'center',
            alignSelf:'center',
            height: '100%',
            position : 'absolute',
            zIndex: 1, //For iOS
            //elevation: 1 // For Android

            borderWidth: 0, // Remove Border
            shadowColor: 'rgba(0,0,0, 0.0)', // Remove Shadow for iOS
            shadowOffset: { height: 0, width: 0 },
            shadowOpacity: 0,
            shadowRadius: 0,
            elevation: 0 // Remove Shadow for Android
            }}>
            
            {/* <Text2 name = "" bbb={this.props.bindEvent} style={styles.title_big} ggg={()=>{return(this.props.oData.last_size == 0? " " : ConnectionMkt.getFmt(this.props.oData.last, this.props.oData))}}></Text2> */}
            <Text2 name = "" bbb={this.props.bindEvent} style={[FontInfo.appStyles.txt_black, styles.title_big, {fontSize:FontInfo.iFontSize + 23, color:FontInfo.sForeground}]} ggg={this.GetTradePrice}></Text2>
          </View>
          </View>

          <View style={{ width:Utilities.WIDTH, backgroundColor:'transparent', flexDirection: "row", }}>
            <Text2 name = "" bbb={this.props.bindEvent} style={[FontInfo.appStyles.txt_bold, {color: 'dodgerblue', flex:1, textAlign:"right"}]} ggg={()=>{return(!this.props.oData.bid_size? " " : this.props.oData.bid_size)}}></Text2>
            <Text2 name = "" bbb={this.props.bindEvent} style={[FontInfo.appStyles.txt_bold, {color: 'gainsboro', paddingHorizontal:4}]} ggg={()=>{return(!this.props.oData.bid_size? "No Bid" : "@");}}></Text2>
            <Text2 name = "" bbb={this.props.bindEvent} style={[FontInfo.appStyles.txt_bold, {color: 'dodgerblue', flex:1,}]} ggg={()=>{return(!this.props.oData.bid_size? " " : ConnectionMkt.getFmt(this.props.oData.bid, this.props.oData))}}></Text2>
          </View>
          </View>

        {/* SEP */}
        <View style={[styles.separator, {backgroundColor:FontInfo.sDivider}]} />

        {/* CHANGE */}
          <View style={styles.view_nc}>
            <View style={{flex:1, alignItems:'flex-end', backgroundColor:'transparent'}}>
            {/* <View > */}
             <Text4 name = "" bbb={this.props.bindEvent} 
                  getstyle={()=>{return(this.props.oData.pc >= 0? 
                  [FontInfo.appStyles.txt_bold, styles.title_small_green, {backgroundColor: FontInfo.sGreen,}] : [FontInfo.appStyles.txt_bold, styles.title_small_red])}} 
                  style={[FontInfo.appStyles.txt_bold, styles.title_small_text]}
                  ggg={()=>{return(this.props.oData.nc < 0? ConnectionMkt.getFmt(this.props.oData.nc, this.props.oData) : "+" + ConnectionMkt.getFmt(this.props.oData.nc, this.props.oData))}}></Text4>
            {/* </View> */}
            </View>

            <View style={{flex:1, backgroundColor:'transparent'}}>
            <Text3 name = "" bbb={this.props.bindEvent} 
              getstyle={()=>{return(this.props.oData.pc >= 0? 
                [FontInfo.appStyles.txt_bold, styles.title_small_green_0, {color: FontInfo.sGreen,}] : [FontInfo.appStyles.txt_bold, styles.title_small_red_0]
                
                
                )}  } 
              ggg={()=>{return(this.props.oData.pc < 0? this.props.oData.pc.toFixed(2) + "%" : "+" + this.props.oData.pc.toFixed(2) + "%")}}></Text3>
            </View>
          </View>

          <View style={[styles.separator, {backgroundColor:FontInfo.sDivider}]} />


        <View style={{marginBottom:5, width:'100%', backgroundColor:'transparent'}}>
        <Order bindEvent={this.props.bindEvent} onSelectAccount={this.props.onSelectAccount} oData={this.props.oData} 
                          ref={node => { this.oOrderRef = node; }} 
                          iSettIndex={this.props.iSettIndex}
                          />
        <ChartConfig oData={this.props.oData} ref={node => { this.oChartConfig = node; }} 
                       iSettIndex={this.props.iSettIndex}
                        />
        <View style={[styles.separator, {backgroundColor:FontInfo.sDivider}]} />
        </View>

        {/* CHART */}
        <LookBackBar oData={this.props.oData} qbRef={this} />
        
        <ChartEx ref={node => { this.oChartRef = node; }} bindEvent={this.props.bindEvent} oData={this.props.oData} qbRef={this}
                 iSettIndex={this.props.iSettIndex}/>

          {/* {console.log(props.closes_got)} */}
          {/* SEP */}
          <View style={[styles.separator, {backgroundColor:FontInfo.sDivider}]} />

          <View style={styles.view_center}>
            {/* <Text>{new Date().toTimeString()}</Text> */}
            {/* MODE */}
            <Text3 name = "" bbb={this.props.bindEvent} getstyle={()=>{return([FontInfo.appStyles.txt_bold, styles.row_vol, {marginTop:2, color: Utilities.getModeColor(this.props.oData.mode)}])}} ggg={()=>{return(this.props.oData.mode)}}></Text3>

            {/* VOL */}
            <Text2 name = "" bbb={this.props.bindEvent} style={[FontInfo.appStyles.txt_normal, styles.row_vol]} ggg={()=>{return(this.props.oData.vol == 0? " " : this.props.oData.vol.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + " traded")}}></Text2>

            {/* TIME */}
            <View style={{alignSelf:'center', width:'100%', backgroundColor:'transparent'}}>
              {/* <TouchableOpacity style={{position:'absolute', left:-4, bottom:-9, width:40, height:40, borderRadius:20, alignContent:'center', backgroundColor:'transparent', justifyContent:'center'}} onPress={()=>{this.oOrderRef?.ShowSymbolProps()}}>
              <Octicons style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3, opacity:.8 }} name="three-bars" size={16} color={'slategrey'} /> */}
              {/* <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="bars" size={12} color={'gainsboro'} /> */}
              {/* <Text style={{backgroundColor:'yellow', color:'red', fontSize:16}}>⚙️</Text> */}
              {/* </TouchableOpacity> */}

              <Text2 name = "" bbb={this.props.bindEvent} style={[FontInfo.appStyles.txt_normal, styles.row_vol, {alignSelf:'center', textAlign:'right'}]} ggg={()=>{return(this.props.oData.time != 0? Utilities.formatTime(new Date(this.props.oData.time * 1000)) : " ")}}></Text2>
              {/* <Text2 name = "" bbb={this.props.bindEvent} style={[styles.row_time, {position:'absolute', backgroundColor:'white', minWidth:40, right:8, color:'gainsboro', textAlign:'right', marginLeft:4}]} ggg={()=>{return((this.props.oData.time != 0? "" : "") + (this.props.oData.msgs != 0? this.props.oData.msgs.toString() : " "))}}></Text2> */}
            </View>
          </View>
          </View>
  );
}
}

/*   ---------------------------------------------------------------------   */

const styles = StyleSheet.create({
  container: 
  {
    flex: 1,
    margin: 10,
  },

  title_big: {
    paddingHorizontal:2,
    fontSize: 35,
    color:'black',
  },

  title_small_red_0: {
    marginLeft:4,
    color: 'red',
  },

  title_small_green_0: {
    marginLeft:4,
    color: 'green',
  },  

  title_small_red: {
    color: 'white',
    backgroundColor: 'red',
    borderRadius: 4,
    paddingRight:2,
  },

  title_small_green: {
    color: 'white',
    backgroundColor: 'green',

    borderRadius: 4,  
    paddingRight:2,
  },  

  title_small_text: {
    marginLeft:4,
    color: 'white',
    backgroundColor: 'transparent',
  },  

  row_vol: {
    paddingVertical:0,
    color: 'grey',
    },    

  row_last: {
    marginLeft:2,
    color: 'grey',
  },

  header_close: {
    alignContent:'center',
    justifyContent:'center',
    width:40,
    height:28,
    position:'absolute',
    right:0,
  },

   symbol_container: {
    margin: 8,
    backgroundColor: 'transparent',
    borderWidth: 0,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    borderColor: 'rgba(255,255,255,0.1)',
  },

  symbol_container_0: {
    alignSelf: 'center',
    margin: 20,
    width:Utilities.WIDTH,
   //flex: 0.5,
   backgroundColor: 'transparent',

   borderRadius: 20,
 },

 view_center: {
  paddingTop:4, 
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'transparent',
},

view_nc: {
  flexDirection:'row',
  paddingTop:8, 
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'transparent'
},

  separator: {
    alignSelf: 'center',
    marginTop: 8,
    height: 1,
    width: (Utilities.WIDTH * 0.8) - 16, //'80%',
  },
});
